

























import { Component, Mixins, Prop } from 'vue-property-decorator';
import AnomalyViewMixin from '@/pages/audits/dashboard/AnomalyViewMixin';
import { snapshot_inspection } from '@/types/intrador';
import ImageViewer from '@/components/ImageViewer.vue';
import Polaroid from '@/components/Polaroid.vue';

@Component({
  components: {
    ImageViewer,
    Polaroid,
  },
})
export default class DemoAnomalyView extends Mixins(AnomalyViewMixin) {
  @Prop(Object) protected inspection!: snapshot_inspection;

  protected namespace: string = 'TimesInDemonstration';
  protected message = 'TIMES_IN_DEMONSTRATION';
  protected level = 'ERROR';

  protected openImage(id: string) {
    this.$nextTick(() => {
      this.$emit('open', id);
    });
  }

  protected get demoValue() {
    return this.inspection.parameterValues?.find((value) => value?.parameter?.id === '1132');
  }
}
